// apps/periverse/src/app/utils/init-mf.ts
import { init } from '@module-federation/runtime';

type ModuleFederationWindow = Window & {
  __FEDERATION_DEBUG__?: boolean;
  __MF_DEBUG__?: boolean;
};

const moduleFederationWindow = window as ModuleFederationWindow;

moduleFederationWindow.__FEDERATION_DEBUG__ = true;
moduleFederationWindow.__MF_DEBUG__ = true;

/**
 * Reads URLs from the global config and creates the Module Federation instance.
 */
export async function initializeFederation() {
  const runtimeConfig = window.__RUNTIME_CONFIG__;

  if (!runtimeConfig) {
    throw new Error(
      'MF INIT ERROR: __RUNTIME_CONFIG__ is missing. Deployment setup may be incorrect.'
    );
  }

  console.log('MF INIT: Reading URLs from window.__RUNTIME_CONFIG__...');

  const {
    REMOTE_PERI_TRACK_URL,
    REMOTE_PERI_TRAY_URL,
    REMOTE_PERI_THEATRE_URL,
  } = runtimeConfig;

  const remotesList = [
    { name: 'peri_track', entry: `${REMOTE_PERI_TRACK_URL}/remoteEntry.js` },
    { name: 'peri_tray', entry: `${REMOTE_PERI_TRAY_URL}/remoteEntry.js` },
    {
      name: 'peri_theatre',
      entry: `${REMOTE_PERI_THEATRE_URL}/remoteEntry.js`,
    },
  ].filter(
    (
      r
    ): r is {
      name: string;
      entry: string;
    } => Boolean(r.entry && r.name)
  );

  if (remotesList.length === 0) {
    throw new Error('MF INIT ERROR: No remote URLs found in runtime config.');
  }

  await init({
    name: 'periverse',
    remotes: remotesList,
  });

  console.log('✅ MF INIT: Runtime Instance Initialized.');
  console.log(
    'Registered Remotes:',
    remotesList.map((r) => r.name)
  );
}
